<template>
    <transition name="fade" mode="out-in" appear>
        <div class="wrapper">
            <the-navigation-side-bar :is-show="isShowNavigationBar" @show-change="showChange" />
            <the-header-title @switching="isShowNavigationBar = !isShowNavigationBar" />
            <the-content-pane class="base" />
        </div>
    </transition>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import TheNavigationSideBar from '../organisms/layout/TheNavigationSideBar.vue';
import TheHeaderTitle from '../organisms/layout/TheHeaderTitle.vue';
import TheContentPane from '../organisms/layout/TheContentPane.vue';

@Component({
    components: {
        TheNavigationSideBar,
        TheHeaderTitle,
        TheContentPane,
    },
})
export default class ThePageLayout extends Vue {
    isShowNavigationBar: boolean = true;

    showChange(newVal): void {
        this.isShowNavigationBar = newVal;
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
    transition: opacity 0.5s;
}
.fade-enter {
    opacity: 0;
}
</style>
